"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f269 = void 0;
exports.f269 = {
    "čakavian": [
        1501,
        1502
    ],
    "čakavica": [
        1501,
        1502
    ],
    "čakavski": [
        1501,
        1502
    ],
    "čakavština": [
        1501,
        1502
    ],
    "čekavski": [
        1501,
        1502
    ],
    "čokovski": [
        1501,
        1502
    ],
    "čeština": [
        1627,
        1628
    ],
    "český jazyk": [
        1627,
        1628
    ],
    "český": [
        1627,
        1628,
        1633
    ],
    "češki": [
        1627,
        1628
    ],
    "český znakový jazyk": [
        1633
    ],
    "čʼel": [
        6630,
        6631
    ]
};
